import { formatCurrency } from '@/app/utils/formatCurrency';

/** A null value renders an em dash. Sums go through the scaled-integer helpers,
 *  never through this formatter's input. */
export const formatInvoiceMoney = (value: number | null): string => (value === null ? '—' : formatCurrency(value));
